import React, { useState } from "react";
import Map from "../fish-map/Map";
import { Loader } from "../common/Loader";
import { PickedObjectView, TooltipFunc } from "./picked-object-view";
import { PickInfo, ViewStateProps } from "@deck.gl/core/lib/deck";
import { Layer } from "@deck.gl/core";
import { LayerProps } from "@deck.gl/core/lib/layer";
import { useLocation } from "react-router-dom";
import { FishMap } from "./fish-map/fishMap";
import { RoutePlanner } from "./route-planner/routePlanner";
import './index.css'

function MapAppIndex() {

  const [loading, setLoading] = useState<boolean>(false);
  const [pickInfo, setPickInfo] = useState<PickInfo<any> | undefined>();
  const [viewState, setViewState] = useState<ViewStateProps | undefined>(undefined);

  const location = useLocation();

  // TODO: can be made much prettier and React like by using: `JSX with deck.gl Layers`
  //  -> This also allows for react-router

  // In order to use the same DeckGL and Mapbox instance, dynamically load and switch between pages
  // using this technique...
  const fishMapPage = FishMap(setLoading, setViewState);
  const routePlannerPage = RoutePlanner(setLoading, setViewState);
  let lightModeMapStyle: string | undefined;
  const shouldAllowMenuHide = window.innerWidth < 760;
  const [menuHidden, setMenuHidden] = useState(shouldAllowMenuHide);

  const [layers, menus, tooltip] = 
    (() => {if (location.pathname.includes("route")) {
      // lightModeMapStyle = "mapbox://styles/kahole/cl8g1oo3o000z14ol4m23ihkr";
      return routePlannerPage;
    } else {
      return fishMapPage;
    }})();

  return <>
    <Map
      layers={layers}
      getTooltip={tooltip}
      onClick={p => setPickInfo(p)}
      viewState={viewState}
      onViewStateChange={(e) => setViewState(undefined)}
      lightModeMapStyle={lightModeMapStyle}
    />
    {loading && <Loader />}
    <>
    {menuHidden ? 
    <div className="floatingMenusContainer hidden">
      <div className="menu-toggle collapsed" > <button onClick={()=>setMenuHidden(!menuHidden)} className="menu-toggle-btn">{menuHidden ? "v": "ʌ"}</button> </div> 
    </div>
    :
    <div className="floatingMenusContainer">
      {shouldAllowMenuHide && <div className="menu-toggle" > <button onClick={()=>setMenuHidden(!menuHidden)} className="menu-toggle-btn">{menuHidden ? "v": "ʌ"}</button> </div>}
      {menus}
      {pickInfo?.object && <PickedObjectView pickInfo={pickInfo} getTooltip={tooltip} />}
    </div>
    }
    </>
    
  </>;
}

export default MapAppIndex;

export type Page = [Layer<any, LayerProps<any>>[], React.ReactNode, TooltipFunc];
